// src/utils/fetchers.js
// Robust fetchers that try several endpoint shapes and fall back to
// finding the item inside the scoped listing we already know works.
import axios from "axios";
import BASE_URL, { DAJC } from "../config";

const unwrap = (data) =>
  data?.data?.id ? data.data
  : data?.article?.id ? data.article
  : data?.page?.id ? data.page
  : data?.id ? data
  : null;

export async function fetchArticleById(id) {
  const candidates = [
    `/api/articles/${id}`,
    `/api/article/${id}`,
    `/api/article/edit/${id}`,
    `/api/articles/edit/${id}`,
    `/api/articleportail/edit/${id}`,
  ];
  for (const ep of candidates) {
    try {
      const r = await axios.get(`${BASE_URL}${ep}`);
      const item = unwrap(r.data);
      if (item) return item;
    } catch (_) { /* try next */ }
  }
  // Fallback: pull the whole DAJC category and find the article in there
  try {
    const r = await axios.get(
      `${BASE_URL}/api/categoryportail/edit/${DAJC.CATEGORY_ID}`,
      { params: { per_page: 200 } }
    );
    const list = r.data?.articles?.data || [];
    return list.find((a) => String(a.id) === String(id)) || null;
  } catch (_) {
    return null;
  }
}

export async function fetchPageById(id) {
  const candidates = [
    `/api/pages/${id}`,
    `/api/page/${id}`,
    `/api/page/edit/${id}`,
    `/api/pages/edit/${id}`,
    `/api/pageportail/edit/${id}`,
  ];
  for (const ep of candidates) {
    try {
      const r = await axios.get(`${BASE_URL}${ep}`);
      const item = unwrap(r.data);
      if (item) return item;
    } catch (_) { /* try next */ }
  }
  // Fallback: look it up inside the DAJC service listing
  try {
    const r = await axios.get(
      `${BASE_URL}/api/serviceportail/edit/${DAJC.SERVICE_ID}`,
      { params: { per_page: 200 } }
    );
    const list = r.data?.pages?.data || [];
    return list.find((p) => String(p.id) === String(id)) || null;
  } catch (_) {
    return null;
  }
}

export async function fetchRelatedArticles(excludeId, limit = 4) {
  try {
    const r = await axios.get(
      `${BASE_URL}/api/categoryportail/edit/${DAJC.CATEGORY_ID}`,
      { params: { per_page: limit + 2 } }
    );
    const list = r.data?.articles?.data || [];
    return list.filter((a) => String(a.id) !== String(excludeId)).slice(0, limit);
  } catch (_) {
    return [];
  }
}

export async function fetchRelatedPages(excludeId, limit = 8) {
  try {
    const r = await axios.get(
      `${BASE_URL}/api/serviceportail/edit/${DAJC.SERVICE_ID}`,
      { params: { per_page: limit + 2 } }
    );
    const list = r.data?.pages?.data || [];
    return list.filter((p) => String(p.id) !== String(excludeId)).slice(0, limit);
  } catch (_) {
    return [];
  }
}
